import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import {ColumnWrapper, DescWrapper, Button, CardsWrapper} from './style'

const KitsCards = ({props}) => {
    

    const CardsRow = props.map((col)=> {
            return(
                <ColumnWrapper key={col.id}>
                <Col key={col.id}>
                    <DescWrapper>
                    {col.duration} {col.text} <div>{col.currency} {col.price}</div><br/>
                    <Button to={"/"+col.id+"Details"}>
                        {col.button_text}
                    </Button>
                    </DescWrapper>
                </Col>
                </ColumnWrapper>
            )
        })


    return (
        
        <CardsWrapper>
            <Container fluid>
            <Row>
                {CardsRow}
            </Row>
            </Container>
        </CardsWrapper>
    )
}

export default KitsCards




